const TemplateRoutes = [
    {
      path: "/templates",
      name: "Templates",
      component: () => import("@/pages/templates/TemplateListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Project'
        }
      },
      children: [
        {
          path: "new",
          name: "NewTemplate",
          component: () => import("@/pages/templates/NewTemplatePage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Project'
            }
          }
        },
      ]
    },
    {
      path: "/templates/:id",
      name: "OneTemplate",
      component: () => import("@/pages/templates/OneTemplatePage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Project'
        }
      },
      children: [
        {
          path: "stages/:id",
          name: "OneStageDetails",
          component: () => import("@/pages/stages/OneStageDetailsPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'read', on: 'Stage'
            }
          }
        },
        {
          path: "tasks/:id",
          name: "OneTaskDetails",
          component: () => import("@/pages/tasks/ShowTaskPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'read', on: 'Task'
            }
          }
        },
      ]
    }
  ]
  
  export default TemplateRoutes